import { createContext } from 'react';
import { DeviceInput } from '../util/input/device';

export const DeviceInputContext = createContext<{input?: DeviceInput}>({});